import { styled } from 'styled-system/jsx'

const DepositStack = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
})

const DepositHeading = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '16px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const DepositRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap',
  },
})

const DepositAmount = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '18px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const StatusBadge = styled('span', {
  base: {
    paddingX: '10px',
    paddingY: '3px',
    borderRadius: 'pill',
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    textTransform: 'capitalize',
  },
  variants: {
    tone: {
      held: { backgroundColor: '#FFF6E0', color: '#A07A1F' },
      returned: { backgroundColor: '#E7F8EF', color: '#1E7A4D' },
    },
  },
})

const SubLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    textTransform: 'uppercase',
    letterSpacing: '0.4px',
  },
})

const DeductionRow = styled('div', {
  base: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '12px',
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.ink',
  },
})

const ReturnText = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.primary',
  },
})

export {
  DepositStack,
  DepositHeading,
  DepositRow,
  DepositAmount,
  StatusBadge,
  SubLabel,
  DeductionRow,
  ReturnText,
}
